<template>
    <div class="pedido-wrapper">
        <div class="pedido-head">
            <div class="head-wrapper">
                <div class="pedido-id-info">
                    <h3 class="pedido-id-title">
                        <template v-if="pedido.cancelado">
                            Pedido cancelado
                        </template>
                        <template
                            v-else-if="pedido.estado_envio !== 'Completado'"
                        >
                            Pedido en curso
                        </template>
                        <template v-else>
                            Pedido finalizado
                        </template>
                    </h3>
                    <div class="pedido-id-number">
                        PEDIDO Nº {{ pedido.anyo + "/" + pedido.numero }}
                    </div>
                    <div class="pedido-id-semana">
                        SEMANA {{ pedido.semana }}
                    </div>
                    <div class="pedido-fecha" v-if="!pedido.cancelado">
                        Pedido realizado el {{ fechaFormatted }}<br />
                        Fecha de entrega el {{ fechaEntregaFormatted }}
                    </div>
                    <div class="pedido-id-icons">
                        <img
                            src="/img/iconos/custom_default_pedidos.svg"
                            alt="Contiene a medida"
                            class="pedido-id-icon"
                            v-if="hasMedida"
                        />
                        <img
                            src="/img/iconos/disponible_default.svg"
                            alt="Contiene disponible"
                            class="pedido-id-icon"
                            v-if="hasDisponible"
                        />
                        <img
                            src="/img/iconos/icon_ecologico.svg"
                            alt="Contiene ecologicos"
                            class="pedido-id-icon"
                            v-if="hasEco"
                        />
                    </div>
                </div>
                <div class="pedido-pricing">
                    <div class="pedido-princing-width">
                        <div class="price-info-line">
                            <div class="price-info-desc">Gastos de envío</div>
                            <div class="price-info-val">
                                {{ pedido.importe_envio | formatMoney }}
                            </div>
                        </div>
                        <div class="price-info-line">
                            <div class="price-info-desc">Base</div>
                            <div class="price-info-val">
                                {{ pedido.base_imponible | formatMoney }}
                            </div>
                        </div>
                        <div class="price-info-line">
                            <div class="price-info-desc">IVA</div>
                            <div class="price-info-val">
                                {{ pedido.iva | formatMoney }}
                            </div>
                        </div>
                        <div class="price-info-line">
                            <div class="price-info-desc">RE</div>
                            <div class="price-info-val">
                                {{ pedido.recargo_equivalencia | formatMoney }}
                            </div>
                        </div>
                        <div class="price-info-line font-weight-bold">
                            <div class="price-info-desc">Importe total</div>
                            <div class="price-info-val">
                                {{ pedido.precio_total | formatMoney }}
                            </div>
                        </div>
                        <div
                            v-if="
                                !pedido.cancelado &&
                                    pedido.diferencia_transacciones_pedido_parcial >
                                        0
                            "
                            class="price-info-line precio-info-line-pendiente"
                        >
                            <div class="price-info-desc">
                                <template v-if="!pedido.blocked_at">
                                    Pendiente de pago ahora*
                                </template>
                                <template v-else>
                                    Pendiente de pago*
                                </template>
                            </div>
                            <div class="price-info-val">
                                {{
                                    pedido.diferencia_transacciones_pedido_parcial
                                        | formatMoney
                                }}
                            </div>
                            <div class="price-info-more-info">
                                {{ moreInfoPendientePago }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pedido-actions">
                    <template v-if="!pedido.cancelado">
                        <div
                            class="pedido-btn-wrapper"
                            v-if="
                                pedido.estado_envio === 'Pendiente' &&
                                    !pedido.check_factura
                            "
                        >
                            <button
                                class="pedido-btn cancelar-pedido-btn"
                                @click="cancelOrder"
                            >
                                Cancelar pedido
                                <div class="pedido-id-icon-positioner">
                                    <cancel-icon></cancel-icon>
                                </div>
                            </button>
                        </div>
                        <div
                            class="pedido-btn-wrapper"
                            v-if="
                                pedido.estado_envio === 'Pendiente' &&
                                    !pedido.check_factura
                            "
                        >
                            <button
                                class="pedido-btn editar-pedido-btn"
                                @click="goToEditPedido"
                            >
                                Editar pedido
                                <div class="pedido-id-icon-positioner">
                                    <edit-icon></edit-icon>
                                </div>
                            </button>
                        </div>
                        <div
                            class="pedido-btn-wrapper"
                            v-if="pedido.avaiableCertificado"
                        >
                            <button
                                class="pedido-btn descargar-pedido-btn"
                                @click="downloadCertificadoEco"
                            >
                                Descargar certificado ECO
                                <div class="pedido-id-icon-positioner">
                                    <download-icon></download-icon>
                                </div>
                            </button>
                        </div>
                        <div class="pedido-btn-wrapper" v-if="pedido.need_pay">
                            <button
                                class="pedido-btn pagar-pedido-btn"
                                @click="goToPay"
                            >
                                Ir a pagar
                                <div class="pedido-id-icon-positioner">
                                    <pay-icon></pay-icon>
                                </div>
                            </button>
                        </div>
                        <div
                            class="pedido-btn-wrapper"
                            v-if="pedido.check_factura"
                        >
                            <button
                                class="pedido-btn descargar-factura-pedido-btn"
                                @click="downloadFactura"
                            >
                                Descargar factura
                                <div class="pedido-id-icon-positioner">
                                    <download-icon></download-icon>
                                </div>
                            </button>
                        </div>
                        <div
                            class="pedido-btn-wrapper valorar-pedido-btn-wrapper"
                            v-if="canValorarPedidoBtn"
                        >
                            <valorar-pedido-btn
                                :isRecogidaBabyplant="isRecogidaBabyplant"
                                :valoracion-data="valoracionEntrega"
                                @voted="votedEvent"
                            ></valorar-pedido-btn>
                        </div>
                    </template>
                </div>
                <div
                    class="pedido-progress-dropdown"
                    :class="{ closed: !showProgress }"
                >
                    <div
                        class="pedido-progress-btn-wrapper"
                        @click="showProgress = !showProgress"
                    >
                        Proceso pedido
                        <i v-if="showProgress" class="fas fa-chevron-up"></i>
                        <i v-else class="fas fa-chevron-down"></i>
                    </div>
                </div>
                <pedido-progress
                    v-if="hasMedida"
                    :compra-date="pedido.fecha"
                    :bloqueo-date="pedido.block_to_date"
                    :ultimo-pago-date="pedido.ultimo_dia_pago_completo"
                    :envio-date="pedido.primera_fecha_entrega"
                    :class="{ 'pedido-progress-hidden': !showProgress }"
                ></pedido-progress>
                <pedido-progress-disponible
                    v-else
                    :compra-date="pedido.fecha"
                    :ultimo-pago-date="pedido.ultimo_dia_pago_completo"
                    :envio-date="pedido.primera_fecha_entrega"
                    :class="{ 'pedido-progress-hidden': !showProgress }"
                ></pedido-progress-disponible>
            </div>
        </div>
        <div class="detalles-btn-wrapper" @click="showDetails = !showDetails">
            Detalles del pedido
            <i v-if="showDetails" class="fas fa-chevron-up"></i>
            <i v-else class="fas fa-chevron-down"></i>
        </div>
        <div class="lineas-pedido" v-show="showDetails">
            <pedido-linea-perfil
                v-for="line in pedido.lineas"
                :key="line.id"
                line-type="Disponible"
                :line="line"
            ></pedido-linea-perfil>
            <pedido-linea-perfil
                v-for="line in pedido.lineas_medida"
                :key="line.id"
                line-type="Medida"
                :line="line"
            ></pedido-linea-perfil>
        </div>
    </div>
</template>

<script>
import PedidoLineaPerfil from "./PedidoLineaPerfil";
import PedidoProgress from "./PedidoProgress";
import DownloadIcon from "./DownloadIcon";
import EditIcon from "./EditIcon";
import CancelIcon from "./CancelIcon";
import PayIcon from "./PayIcon";
import ValorarPedidoBtn from "./ValorarPedidoBtn";
import PedidoProgressDisponible from "./PedidoProgressDisponible";
export default {
    name: "PedidoPerfil",
    components: {
        PedidoProgressDisponible,
        ValorarPedidoBtn,
        PayIcon,
        CancelIcon,
        EditIcon,
        DownloadIcon,
        PedidoProgress,
        PedidoLineaPerfil
    },
    props: {
        pedido: {}
    },
    data() {
        return {
            showDetails: false,
            showProgress: false
        };
    },
    computed: {
        fechaFormatted() {
            return moment(this.pedido.fecha).format("LL");
        },
        fechaEntregaFormatted() {
            return moment(this.pedido.primera_fecha_entrega).format("LL");
        },
        hasEco() {
            let eco = false;
            if (this.pedido.lineas.some(l => !!l.ecologico)) {
                eco = true;
            }
            if (this.pedido.lineas_medida.some(l => !!l.ecologico)) {
                eco = true;
            }
            return eco;
        },
        hasDisponible() {
            return this.pedido.lineas.length > 0;
        },
        hasMedida() {
            return this.pedido.lineas_medida.length > 0;
        },
        moreInfoPendientePago() {
            let info = "*Se cancelará el pedido si no está pagado antes del ";
            if (
                !this.pedido.blocked_at &&
                this.pedido.total_transacciones <
                    this.pedido.precio_total_now &&
                this.pedido.block_to_date !== null
            ) {
                info += moment(this.pedido.block_to_date).format("D [de] MMMM");
            } else {
                info += moment(this.pedido.ultimo_dia_pago_completo).format(
                    "D [de] MMMM"
                );
            }
            return info;
        },
        valoracionEntrega() {
            let valoracion = null;
            if (this.pedido.valoraciones_entrega.length > 0) {
                valoracion = this.pedido.valoraciones_entrega[
                    this.pedido.valoraciones_entrega.length - 1
                ];
            }
            return valoracion;
        },
        hasValoracionEntregaNotVoted() {
            let has = false;
            if (this.valoracionEntrega) {
                if (!this.valoracionEntrega.voted) {
                    has = true;
                }
            }
            return has;
        },
        canValorarPedidoBtn() {
            return (
                this.pedido.check_factura && this.hasValoracionEntregaNotVoted
            );
        },
        isRecogidaBabyplant() {
            let is = false;
            if (this.pedido.transportista) {
                is = this.pedido.transportista.id === 2;
            }
            return is;
        }
    },
    methods: {
        cancelOrder: function() {
            if (
                confirm(
                    "¿Estas seguro que deseas cancelar el pedido?, Este proceso no se puede revertir."
                )
            ) {
                axios
                    .post(this.route("account.pedidos.cancel"), {
                        pedido_id: this.pedido.id
                    })
                    .then(response => {
                        this.$emit("canceled");
                        Vue.toasted.show(response.data.info, {
                            type: "success",
                            duration: 3000
                        });
                    })
                    .catch(e => {
                        Vue.toasted.show(
                            e.response.data.info
                                ? e.response.data.info
                                : "Ha habido un error!",
                            {
                                type: "error",
                                duration: 3000
                            }
                        );
                        console.log(e);
                    });
            }
        },
        goToPay() {
            window.location = this.route(
                "account.pedidos.pagar",
                this.pedido.id
            );
        },
        downloadCertificadoEco() {
            window.location = this.route("download.certificado.eco");
        },
        goToEditPedido() {
            window.location = this.route(
                "account.pedidos.editar",
                this.pedido.id
            );
        },
        downloadFactura() {
            window.location = this.route("account.pdf.pedidos", this.pedido.id);
        },
        votedEvent() {
            if (this.hasValoracionEntregaNotVoted) {
                this.valoracionEntrega.voted = 1;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.pedido-wrapper {
    width: 100%;
    border: solid 3px #646464;
    margin-bottom: 1rem;
}

.pedido-head {
    background-color: #f2f2f2;
    padding: 0.75rem;
}

.head-wrapper {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.pedido-id-info {
    flex: 1 0 33%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.pedido-pricing {
    flex: 1 0 33%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    display: flex;
    justify-content: center;
}

.pedido-actions {
    flex: 1 1 33%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
}

.pedido-id-number {
    font-weight: bold;
    letter-spacing: -1px;
    line-height: 1;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    display: inline-block;
}

.pedido-id-semana {
    display: inline-block;
}

.pedido-fecha {
    display: inline-block;
}

.pedido-id-icons {
    margin-top: 1rem;
    margin-left: -5px;
}

.pedido-id-icon {
    margin-left: 5px;
    height: 2rem;
}

.pedido-id-title {
    font-weight: bold;
    letter-spacing: -1px;
    line-height: 1;
}

.pedido-id-number {
    font-weight: bold;
}

.pedido-id-semana {
    font-weight: bold;
}

.pedido-princing-width {
    flex: 0 1 250px;
}

.price-info-line {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
}

.precio-info-line-pendiente {
    font-weight: bold;
    color: #c1272d;
}

.price-info-val {
    margin-left: auto;
}

.price-info-more-info {
    flex: 1 1 100%;
    font-weight: normal;
}

.pedido-btn-wrapper {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

.pedido-btn {
    color: #6c757d;
    cursor: pointer;
    text-decoration: none;
    border-radius: 0 !important;
    display: block;
    width: 100%;
    transition: none;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 3px solid #6c757d;
    padding: 0.375rem 2rem;
    font-size: 0.9rem;
    line-height: 1.6;
    text-transform: none;
    position: relative;
}

.pedido-btn:hover {
    color: #fff;
    background-color: #6c757d;
}

.pedido-id-icon-positioner {
    position: absolute;
    right: 5%;
    top: 0;
    width: 1.4em;
    height: 100%;
    display: flex;
    align-items: center;
}

.pedido-btn img {
    width: 100%;
}

.cancelar-pedido-btn {
    color: #c1272d;
    border-color: #c1272d;
}

.cancelar-pedido-btn:hover {
    background-color: #c1272d;
}

.editar-pedido-btn {
    color: #0071bc;
    border-color: #0071bc;
}

.editar-pedido-btn:hover {
    background-color: #0071bc;
}

.descargar-pedido-btn {
    color: #61a60e;
    border-color: #61a60e;
}

.descargar-pedido-btn:hover {
    background-color: #61a60e;
}

.pagar-pedido-btn {
    color: #006030;
    border-color: #006030;
}

.pagar-pedido-btn:hover {
    background-color: #006030;
}

.descargar-factura-pedido-btn {
    color: #0066cc;
    border-color: #0066cc;
}

.descargar-factura-pedido-btn:hover {
    background-color: #0066cc;
}

.detalles-btn-wrapper {
    border-top: solid 1px #646464;
    padding: 0.75rem;
    font-size: 1.3em;
    font-weight: bold;
    color: #0071bc;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}

.detalles-btn-wrapper:hover {
    background-color: #0071bc;
    color: #fff;
}

.pedido-progress-dropdown {
    width: 100%;
}

.pedido-progress-btn-wrapper {
    display: none;
}

@media screen and (max-width: 991px) {
    .pedido-actions {
        flex: 1 1 100%;
        margin-top: 1rem;
    }

    .pedido-progress-hidden {
        display: none;
    }

    .pedido-progress-btn-wrapper {
        border: solid 1px #646464;
        border-left: 0;
        border-right: 0;
        padding: 0.75rem;
        font-size: 1.3em;
        font-weight: bold;
        color: #007b82;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor: pointer;
        display: block;
    }

    .pedido-progress-btn-wrapper:hover {
        background-color: #007b82;
        color: #fff;
    }

    .pedido-progress-dropdown {
        width: calc(100% + 0.5rem);
        margin-left: -0.25rem;
        margin-right: -0.25rem;
        margin-top: 0.75rem;
    }

    .pedido-progress-dropdown.closed {
        margin-bottom: -0.75rem;
    }

    .pedido-progress-dropdown.closed .pedido-progress-btn-wrapper {
        border-bottom: 0;
    }
}

@media screen and (max-width: 575px) {
    .pedido-wrapper {
        border-left: 0;
        border-right: 0;
        border-top-width: 2px;
        border-bottom-width: 2px;
        margin-left: -30px;
        margin-right: -30px;
        width: calc(100% + 60px);
    }

    .pedido-btn {
        border-width: 1px;
    }

    .pedido-id-icons {
        margin-top: 0.75rem;
    }

    .pedido-pricing {
        flex-basis: 100%;
        justify-content: flex-start;
        margin-top: 0.75rem;
    }
}
</style>
